module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "xs": 24,
      "md": 10
    }
  }, [_c('h2', {
    staticClass: "mb15"
  }, [_c('Dropdown', {
    on: {
      "on-click": _vm.selectCampaign
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "gear-b"
    }
  }), _vm._v("\n                            " + _vm._s(_vm.$store.state.selectedCampaign.titulo) + "\n                            "), _c('Icon', {
    attrs: {
      "type": "arrow-down-b"
    }
  })], 1), _vm._v(" "), _c('Dropdown-menu', {
    slot: "list"
  }, _vm._l((_vm.$store.state.campaigns), function(campaign) {
    return _c('Dropdown-item', {
      key: ("opt_dropdown_" + (campaign.id)),
      attrs: {
        "selected": _vm.$store.state.selectedCampaign.id === campaign.id,
        "name": campaign.id
      }
    }, [_vm._v("\n                                " + _vm._s(campaign.titulo) + "\n                            ")])
  }))], 1)], 1)]), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "md": 14
    }
  }, [_c('h2', {
    staticClass: "mb15"
  }, [_vm._v("\n                     \n                    "), _c('i-button', {
    staticClass: "pantallas-header-btn float-right",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "arrow-left-c",
      "size": "18"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml10"
  }, [_vm._v("Volver")])], 1)], 1)])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "type": "flex",
      "gutter": 15
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "md": 16
    }
  }, [_c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.selectedCampaign.descripcion),
      expression: "$store.state.selectedCampaign.descripcion"
    }],
    staticClass: "mb15"
  }, [_vm._v(_vm._s(_vm.$store.state.selectedCampaign.descripcion))]), _vm._v(" "), _c('Row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('i-form', {
    ref: "formFilter",
    attrs: {
      "model": _vm.formFilter,
      "rules": _vm.rulesFilter,
      "inline": ""
    }
  }, [_c('Form-item', {
    staticClass: "mb10",
    attrs: {
      "prop": "estado",
      "label": ""
    }
  }, [_c('i-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Por estado"
    },
    model: {
      value: (_vm.formFilter.estado),
      callback: function($$v) {
        _vm.formFilter.estado = $$v
      },
      expression: "formFilter.estado"
    }
  }, [_c('i-option', {
    attrs: {
      "value": "1",
      "label": "Activo"
    }
  }), _vm._v(" "), _c('i-option', {
    attrs: {
      "value": "0",
      "label": "Inactivo"
    }
  })], 1)], 1), _vm._v(" "), _c('Form-item', {
    staticClass: "mb10",
    attrs: {
      "prop": "periodo",
      "label": ""
    }
  }, [_c('i-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Por período"
    },
    model: {
      value: (_vm.formFilter.periodo),
      callback: function($$v) {
        _vm.formFilter.periodo = $$v
      },
      expression: "formFilter.periodo"
    }
  }, [_c('i-option', {
    attrs: {
      "value": "0",
      "label": "Permanentes"
    }
  }), _vm._v(" "), _c('i-option', {
    attrs: {
      "value": "1",
      "label": "Vigentes"
    }
  }), _vm._v(" "), _c('i-option', {
    attrs: {
      "value": "2",
      "label": "Expirados"
    }
  }), _vm._v(" "), _c('i-option', {
    attrs: {
      "value": "3",
      "label": "Próximamente"
    }
  })], 1)], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formFilter.periodo === '1'),
      expression: "formFilter.periodo === '1'"
    }],
    staticClass: "mb10",
    attrs: {
      "prop": "periodo",
      "label": ""
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Fecha",
      "clearable": false
    },
    model: {
      value: (_vm.formFilter.fecha),
      callback: function($$v) {
        _vm.formFilter.fecha = $$v
      },
      expression: "formFilter.fecha"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('span', {
    staticClass: "float-right mt10"
  }, [_c('Checkbox', {
    model: {
      value: (_vm.showAudio),
      callback: function($$v) {
        _vm.showAudio = $$v
      },
      expression: "showAudio"
    }
  }, [_vm._v("Audio")]), _vm._v(" "), _c('Checkbox', {
    model: {
      value: (_vm.showFotos),
      callback: function($$v) {
        _vm.showFotos = $$v
      },
      expression: "showFotos"
    }
  }, [_vm._v("Fotos")]), _vm._v(" "), _c('Checkbox', {
    model: {
      value: (_vm.showVideos),
      callback: function($$v) {
        _vm.showVideos = $$v
      },
      expression: "showVideos"
    }
  }, [_vm._v("Videos")])], 1)])], 1), _vm._v(" "), _c('Row', {
    staticClass: "mb10",
    attrs: {
      "type": "flex",
      "gutter": 10
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "md": 16
    }
  }, [_c('Radio-group', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "type": "button"
    },
    model: {
      value: (_vm.view),
      callback: function($$v) {
        _vm.view = $$v
      },
      expression: "view"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "grid"
    }
  }, [_c('Icon', {
    staticClass: "mt5",
    attrs: {
      "type": "grid",
      "size": "18"
    }
  })], 1), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "table"
    }
  }, [_c('Icon', {
    staticClass: "mt5",
    attrs: {
      "type": "navicon",
      "size": "18"
    }
  })], 1)], 1), _vm._v(" "), _c('i-button', {
    staticClass: "pantallas-header-btn ml10",
    attrs: {
      "type": "warning",
      "disabled": !_vm.selectedFilteredFiles.length || _vm.isDisabled
    },
    on: {
      "click": _vm.deleteSelectedFiles
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-trash",
      "size": "18"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml10"
  }, [_vm._v("Eliminar " + _vm._s(_vm.selectedFilteredFiles.length) + " archivos")])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('p', {
    staticClass: "text-right mt10",
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("Mostrando " + _vm._s(_vm.filteredFiles.length) + " de " + _vm._s(_vm.$store.state.archivos_publicidad.length) + " archivos")])])], 1), _vm._v(" "), (_vm.view === 'grid') ? _c('transition-group', {
    staticClass: "ivu-row-flex mb10 mrn5 mln5",
    attrs: {
      "name": "list-complete",
      "tag": "div"
    }
  }, _vm._l((_vm.filteredFiles), function(item) {
    return _c('div', {
      key: ("col_file_" + (item.id)),
      staticClass: "mb10 ivu-col ivu-col-span-xs-12 ivu-col-span-md-8 pl5 pr5 list-complete-item"
    }, [_c('Card', [_c('p', {
      slot: "title"
    }, [_c('Checkbox-group', {
      model: {
        value: (_vm.selectedFiles),
        callback: function($$v) {
          _vm.selectedFiles = $$v
        },
        expression: "selectedFiles"
      }
    }, [_c('Checkbox', {
      attrs: {
        "label": item.id,
        "disabled": _vm.isDisabled
      }
    }, [_c('span', [_vm._v(_vm._s(item.nombre_archivo))])])], 1)], 1), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          _vm.openModal(item)
        }
      }
    }, [(item.tipo_archivo === 'Foto') ? _c('span', [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "75px",
        "object-fit": "cover"
      },
      attrs: {
        "src": item.archivo,
        "alt": item.nombre_archivo
      }
    })]) : _vm._e(), _vm._v(" "), (item.tipo_archivo === 'Video') ? _c('span', [_c('div', {
      staticStyle: {
        "width": "100%",
        "height": "75px",
        "display": "flex",
        "flex-direction": "column",
        "justify-content": "center",
        "align-items": "center",
        "background": "black"
      }
    }, [_c('Icon', {
      attrs: {
        "type": "ios-play",
        "color": "white",
        "size": "30"
      }
    })], 1)]) : _vm._e()]), _vm._v(" "), _c('p', [_c('i-switch', {
      staticClass: "mt10",
      attrs: {
        "disabled": _vm.isDisabled
      },
      on: {
        "on-change": function($event) {
          _vm.toggleItem($event, item)
        }
      },
      model: {
        value: (item.estado),
        callback: function($$v) {
          item.estado = $$v
        },
        expression: "item.estado"
      }
    }, [_c('Icon', {
      attrs: {
        "type": "android-done"
      },
      slot: "open"
    }), _vm._v(" "), _c('Icon', {
      attrs: {
        "type": "android-close"
      },
      slot: "close"
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "float-right"
    }, [_c('i-button', {
      staticClass: "mt10",
      attrs: {
        "type": "success",
        "size": "small",
        "disabled": _vm.isDisabled
      },
      on: {
        "click": function($event) {
          _vm.editArchivo(item)
        }
      }
    }, [_vm._v("\n                                        Editar\n                                    ")])], 1)], 1), _vm._v(" "), _c('p', {
      staticClass: "mt5"
    }, [_c('Icon', {
      attrs: {
        "type": "calendar"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "fs12"
    }, [_vm._v(_vm._s(_vm.formatDate(item.fecha_inicio, item.fecha_fin)))])], 1)])], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.view === 'table') ? _c('Row', {
    attrs: {
      "type": "flex",
      "gutter": 10
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.tableColumns,
      "data": _vm.filteredFiles
    },
    on: {
      "on-selection-change": _vm.onSelectAll
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('Modal', {
    ref: "modalPreview",
    attrs: {
      "title": "Vista Previa"
    },
    on: {
      "on-ok": _vm.onModalClose
    },
    model: {
      value: (_vm.modalPreviewVisible),
      callback: function($$v) {
        _vm.modalPreviewVisible = $$v
      },
      expression: "modalPreviewVisible"
    }
  }, [(_vm.selectedItem && _vm.selectedItem.tipo_archivo === 'Foto') ? _c('span', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto",
      "object-fit": "cover"
    },
    attrs: {
      "src": _vm.selectedItem.archivo,
      "alt": _vm.selectedItem.nombre_archivo
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.selectedItem && _vm.selectedItem.tipo_archivo === 'Video') ? _c('span', [_c('video', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.selectedItem.archivo
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "success",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.$refs.modalPreview.close()
      }
    }
  }, [_vm._v("Aceptar")])], 1)])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('Card', [_c('p', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "plus-round"
    }
  }), _vm._v("\n                        Agregar archivos\n                    ")], 1), _vm._v(" "), _c('i-form', {
    ref: "formPublicidad",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "nombre",
      "label": "Nombre"
    }
  }, [_c('i-input', {
    attrs: {
      "size": "large",
      "disabled": _vm.isDisabled
    },
    model: {
      value: (_vm.form.nombre),
      callback: function($$v) {
        _vm.form.nombre = $$v
      },
      expression: "form.nombre"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "descripcion",
      "label": "Descripción"
    }
  }, [_c('i-input', {
    attrs: {
      "size": "large",
      "type": "textarea",
      "rows": 3,
      "disabled": _vm.isDisabled
    },
    model: {
      value: (_vm.form.descripcion),
      callback: function($$v) {
        _vm.form.descripcion = $$v
      },
      expression: "form.descripcion"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "texto_audio",
      "label": "Texto dictado"
    }
  }, [_c('i-input', {
    attrs: {
      "size": "large",
      "type": "textarea",
      "rows": 3,
      "disabled": _vm.isDisabled
    },
    model: {
      value: (_vm.form.texto_audio),
      callback: function($$v) {
        _vm.form.texto_audio = $$v
      },
      expression: "form.texto_audio"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "fecha_inicio",
      "label": "Período de vigencia"
    }
  }, [_c('Row', {
    staticStyle: {
      "clear": "both"
    },
    attrs: {
      "type": "flex",
      "gutter": 15
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12
    }
  }, [_c('Date-picker', {
    attrs: {
      "disabled": _vm.isDisabled,
      "type": "date",
      "placement": "top-end",
      "format": "dd-MMM",
      "placeholder": "Inicio de la vigencia"
    },
    model: {
      value: (_vm.form.fecha_inicio),
      callback: function($$v) {
        _vm.form.fecha_inicio = $$v
      },
      expression: "form.fecha_inicio"
    }
  })], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 12
    }
  }, [_c('Date-picker', {
    attrs: {
      "disabled": _vm.isDisabled,
      "type": "date",
      "placement": "top-end",
      "format": "dd-MMM",
      "placeholder": "Término de la vigencia"
    },
    model: {
      value: (_vm.form.fecha_fin),
      callback: function($$v) {
        _vm.form.fecha_fin = $$v
      },
      expression: "form.fecha_fin"
    }
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.isDisabled) ? _c('Form-item', {
    attrs: {
      "prop": "files"
    }
  }, [_c('Upload', {
    ref: "uploader",
    attrs: {
      "multiple": "",
      "type": "drag",
      "headers": _vm.uploadOpts.headers,
      "name": "file",
      "onSuccess": _vm.uploadOpts.onSuccess,
      "onProgress": _vm.uploadOpts.onProgress,
      "onError": _vm.uploadOpts.onError,
      "onRemove": _vm.uploadOpts.onRemove,
      "action": _vm.uploadOpts.url
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#c3282b"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Arrastre aquí los archivos que desea agregar")])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('i-button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "long": "",
      "loading": _vm.isLoading,
      "disabled": _vm.isDisabled,
      "icon": "checkmark-round"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Guardar")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Modal', {
    ref: "modalEditar",
    attrs: {
      "title": "Editar datos del archivo",
      "footerHide": true
    },
    on: {
      "on-ok": _vm.onModalEditarClose
    },
    model: {
      value: (_vm.modalEditarVisible),
      callback: function($$v) {
        _vm.modalEditarVisible = $$v
      },
      expression: "modalEditarVisible"
    }
  }, [(_vm.selectedItem) ? _c('div', [_c('publicidad-edit-form', {
    attrs: {
      "model": _vm.selectedItem
    },
    on: {
      "on-close": _vm.onModalEditarClose
    }
  })], 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f480351"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/publicidad/PublicidadDetail.vue
// module id = 655
// module chunks = 1